<template>
    <div class="scope not-last:mb-4!">
        <div class="scope-title font-600 mb-1"><slot name="title"></slot></div>
        <div class="scope-description line-height-relaxed">
            <slot></slot>
        </div>
    </div>
</template>
